var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDisabledAddTextBoxIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.032 11.117h-3.094m0 0H8.844m3.094 0v3.093m0-3.093V8.023m8.25-2.062v10.312a3.094 3.094 0 0 1-3.094 3.094H6.78a3.094 3.094 0 0 1-3.093-3.094V5.961A3.094 3.094 0 0 1 6.78 2.867h10.313a3.094 3.094 0 0 1 3.093 3.094z",
    stroke: "#10121C",
    strokeOpacity: 0.5,
    strokeWidth: 1.802,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisabledAddTextBoxIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DisabledAddTextBoxIcon.963ee3d5.svg";
export { ForwardRef as ReactComponent };